<template lang="pug">
  .quiz
    span(style="display: none") {{ quizListAndCounter.counter }}
    header
      h2(@click="shuffleQuizzes") {{ i18n(`${quiz ? quiz.type : 'weekday'}_quiz`) }}
      span.quiz-count {{ quizCount }} {{ i18n('quizzes') }}
    article.card-wrapper
      transition(name="slide-fade" mode="out-in")
        weekday-quiz.quiz-card(v-if="!quiz" :key="`${weekdayQuiz.type}-${weekdayQuiz.ref}`" :quiz="weekdayQuiz" @done="onDone")
        month-quiz.quiz-card(v-else-if="quiz.type === types.MONTH" :key="`${quiz.type}-${quiz.ref}`" :quiz="quiz" @done="onDone")
        number-quiz.quiz-card(v-else-if="quiz.type === types.NUMBER" :key="`${quiz.type}-${quiz.ref}`" :quiz="quiz" @done="onDone")
        event-quiz.quiz-card(v-else-if="quiz.type === types.EVENT" :key="`${quiz.type}-${quiz.ref}`" :quiz="quiz" @done="onDone")
        year-quiz.quiz-card(v-else-if="quiz.type === types.YEAR" :key="`${quiz.type}-${quiz.ref}`" :quiz="quiz" @done="onDone")
        moon-phase-quiz.quiz-card(v-else-if="quiz.type === types.MOON_PHASE" :key="`${quiz.type}-${quiz.ref}`" :quiz="quiz" @done="onDone")
          //- year-quiz(:quiz="quiz" @done="onDone")
    footer
      router-link(to="/" tag="button") {{ i18n('done') }}
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'

import { types } from '@/store/quizzes'

import YearQuiz from '../components/YearQuiz'
import EventQuiz from '../components/EventQuiz'
import MonthQuiz from '../components/MonthQuiz'
import NumberQuiz from '../components/NumberQuiz'
import WeekdayQuiz from '../components/WeekdayQuiz'
import MoonPhaseQuiz from '../components/MoonPhaseQuiz'

export default {
  components:{
    YearQuiz,
    EventQuiz,
    MonthQuiz,
    NumberQuiz,
    WeekdayQuiz,
    MoonPhaseQuiz
  },
  name: 'quiz',
  mounted() {
    this.listNumbers();
    this.listMonths();
    this.listEvents();
    this.listQuizzes();
    this.listMoonPhases();
  },
  data() {
    return {
      types,
      counter: 0
    };
  },
  methods: {
    onDone(quiz, data) {
      if (quiz.type === types.WEEKDAY) {
        this.updateWeekdayQuiz({ quiz, data });
      } else {
        this.updateQuiz({ quiz, confidence: data });
      }
      this.counter++;
    },
    shuffleQuizzes() {
      this.counter++;
    },
    onRemove(event) {
      if (window.confirm('Remove?')) {
        this.removeEvent(event);
      }
    },
    ...mapGetters('quizzes', ['todaysQuizzes']),
    ...mapActions('weekdays', ['listMonths', 'listNumbers']),
    ...mapActions('moonPhases', ['listMoonPhases']),
    ...mapActions('quizzes', ['listQuizzes', 'updateQuiz', 'updateWeekdayQuiz']),
    ...mapActions('events', ['removeEvent', 'listEvents'])
  },
  computed: {
    ...mapGetters('locale', ['i18n']),
    ...mapState('quizzes', ['weekdayQuiz']),
    ...mapState('moonPhases', ['phases']),
    ...mapState('events', ['events']),
    ...mapState('weekdays', ['months', 'numbers']),
    quiz() {
      const { quizList } = this.quizListAndCounter;
      return quizList[0];
    },
    quizCount() {
      const { quizList } = this.quizListAndCounter;
      return quizList.length;
    },
    quizListAndCounter() {
      if (!this.events.length || !this.months.length || !this.numbers.length) {
        return { quizList: [], counter: this.counter };
      }
      return {
        counter: this.counter, // Stay reactive
        quizList: []
          .concat(this.todaysQuizzes())
          .map(d => {
            switch (d.type) {
              case types.YEAR: {
                const eventYear = this.events.find(({ id }) => id === d.ref);
                if (eventYear) {
                  return { ...d, event: eventYear };}
                return undefined;
              }
              case types.EVENT: {
                const event = this.events.find(({ id }) => id === d.ref);
                if (event) {
                  return { ...d, event };}
                return undefined;
              }
              case types.MOON_PHASE: {
                const moonPhase = this.phases.find(({ phase }) => phase === d.data.phase);
                if (moonPhase) {
                  return { ...d, moonPhase };}
                return undefined;
              }
              case types.NUMBER: {
                const number = this.numbers.find(({ key }) => key === d.ref);
                if (number) {
                  return { ...d, number };
                }
                return undefined;
              }
              case types.MONTH: {
                const month = this.months.find(({ key }) => key === d.ref);
                if (month) {
                  return { ...d, month };
                }
                return undefined;
              }
              default: {
                return undefined;
              }
            }
          })
          .filter(d => !!d)
          .sort((a, b) => {
            // Year quizzes should be last ones
            if (a.type === types.YEAR && b.type !== types.YEAR) {
              return 1;
            }
            // Add some randomness
            const diff = Math.round((Math.random() - .5) * 1000 * 60 * 60 * 6); // +/- three hours
            return (a.d.intervalDate.getTime() + diff) - b.d.intervalDate.getTime();
          })
      };
    }
  }
}
</script>

<style lang="stylus" scoped>
  @import "../styles/card"

  .quiz
    height 100vh
    height calc(var(--vh) * 100px)
    width 100%
    display flex
    flex-direction column
    justify-content space-between
    background var(--background-color)
    overflow hidden
    @media (prefers-color-scheme: dark)
      background var(--background-color-dark)

  header, footer
    box-size border-box
    padding 2rem
    height calc(var(--vh) * 5px)

  h2
    text-transform uppercase
    margin 0

  .card-wrapper
    display flex
    justify-content center
    align-items center
    flex-direction column
    overflow-y visible
    height calc(var(--vh) * 90px)
  .events
    list-style none
    margin 0 0 1rem
    padding 0
    text-align center
    li
      padding .25rem 0

  .quiz-card
    margin 0
    card-layout(10, 30)

  .slide-fade-enter-active
    transition all .5s ease
  .slide-fade-leave-active
    transition all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0)
  .slide-fade-enter
    margin-top -40px
    margin-bottom 40px
    opacity 0
  .slide-fade-leave-to
    margin-top 40px
    margin-bottom -40px
    opacity 0

</style>
